import React from 'react'

function Table({ children }) {
    return (
        <div className='w-full relative overflow-x-auto'>
            <table className='w-full whitespace-nowrap'>
                {children}
            </table>
        </div>
    )
}

export default Table